export var ERRORS_CODE = {
    ERR_PHONE: 'UREG_ERR_146',
    ERR_AUTH: 'AUTH_ERR_101',
    ERR_REFRESH: 'TS_SYNC',
    ERR_OTP_CODES: {
        AUTH_ERR_122: 'AUTH_ERR_122',
        PASS_ERR_017: 'PASS_ERR_017',
    },
};
export var ERR_GENERIC = {
    message: 'Something went wrong. Please refresh the page and try again.',
};
export var ERR_PHONE = {
    message: 'This phone number is associated with another account. Please try another number.',
};
export var ERR_INVALID_ZIP = {
    message: 'Please provide a valid zip code.',
};
export var ERR_SAVE = {
    message: 'We’re unable to save your changes. Refresh the page and try again.',
};
export var ERR_REDIRECT = {
    message: 'We’re redirecting you to sign in to your account.',
};
export var ERR_PRO_UPGRADE = {
    message: 'We’re sorry. We are unable to register your Pro Xtra account now. Please try again later.',
};
export var ERR_REFRESH = {
    message: "We're sorry! We can't update your details now. Please refresh your page and try again.",
};
export var ERR_PRO_PHONE = {
    message: "We're sorry. This phone number has already been registered. Please provide a different phone number, or call 1-866-333-3551 for assistance.",
};
export var ERR_INCORRECT_OTP = {
    message: 'This code is incorrect.',
};
export var ERR_UNABLE_TO_SAVE = {
    message: "We're unable to save your changes. Please try again.",
};
export var ERR_UNABLE_TO_EXPORT_OR_PRINT = {
    message: 'We’re unable to complete this action. Refresh the page and try again.',
};
export var USER_RESEND_INVITE_ERROR_MESSAGE = {
    message: 'We’re unable to resend this invite. Please try again.',
};
export var ERR_INVALID_EMAIL = {
    message: 'Please provide a valid email.',
};
export var MULTI_RESEND_INVITE_ERROR_MSG = {
    message: "We're unable to resend the invite(s). Please try again.",
};
export var ERR_UNABLE_BULK_ADD = {
    message: "We're sorry. Something went wrong on our end. Please try again.",
};
export var ERR_UNABLE_TO_ADD_OR_EDIT_USER = {
    message: 'Something went wrong. Click the Cancel button below and try again.',
};
export var ERR_UNABLE_TO_SAVE_PAYMENT_PERMISSIONS = {
    message: 'We couldn’t save your Payment Permissions selection. Edit your user below and try again.',
};
